

export enum MelTableTypes {
    TABLE_LOADING = 'TABLE_LOADING',
    TABLE_SUCCESS = 'TABLE_SUCCESS',
    TABLE_FETCHERROR = 'TABLE_FETCHERROR'
}

